import {useState} from "react";
import {useLocation, useOutletContext, useParams} from "react-router-dom";
import {CaptacionService} from "abastecemento/service";
import {captacion_view_adapter} from "abastecemento/model";
import {useNavigateWithReload} from "base/hooks";
import {EntityUpdatePanel} from "base/entity";
import {CaptacionForm} from "../presentational/form";

const UpdateCaptacionPanel = () => {
    const {section} = useParams();
    const location = useLocation();
    const baseLocationPath = location.pathname.split(section)[0];

    const [error, setError] = useState("");
    const navigate = useNavigateWithReload();

    let captacion;
    [captacion] = useOutletContext();

    const handleSubmit = captacion => {
        CaptacionService.update(captacion_view_adapter({...captacion}))
            .then(() => {
                navigate(baseLocationPath, true);
            })
            .catch(error => {
                setError(error);
            });
    };

    const handleFormCancel = () => {
        navigate(baseLocationPath);
    };

    return (
        <EntityUpdatePanel
            form={
                <CaptacionForm
                    captacion={captacion}
                    updatedSection={section}
                    onSubmit={handleSubmit}
                    onCancel={handleFormCancel}
                />
            }
            title="Modificar Captación"
            error={error}
            onCancel={handleFormCancel}
        />
    );
};

export default UpdateCaptacionPanel;
